'use strict';

import angular from 'angular';
import greenBackground from './greenBackground.controller';

export default angular.module('bfastCaptureManagerApp.application.greenBackground', [])
  .controller('AppGreenBackgroundController', greenBackground)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/greenBackground/index.js